import axios from "axios";

export default function ProductionitemFormService(formData, method, productionItemId) {
  let id
  let url
  if(method === 'put') {
    id = formData.id
    url = process.env.REACT_APP_API_HOST + "/production_item/" + productionItemId
  }
  else {
    url = process.env.REACT_APP_API_HOST + "/production_item"
  }
  return axios({
    method: method,
    url: url,
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
